module.exports = __webpack_public_path__ + "img/indexlogo.4e2a2d12.png";